import src from "IMAGE";
export default { src, width: 1800, height: 1293, blurWidth: 0, blurHeight: 0};
